<button
    mat-icon-button
    class="st-cast-secondary-cta-button-save-as"
    [matTooltip]="languageSettings.PSTWebSaveViewSettings"
    [matMenuTriggerFor]="menu">
    <mat-icon class="material-symbols-outlined">save_as</mat-icon>
</button>
<button
    mat-icon-button
    class="st-cast-secondary-cta-button-one"
    [matTooltip]="languageSettings.PSTWebCustomizeTopicCard"
    (click)="openTopicCardCustomFieldsDialog()">
    <mat-icon class="material-symbols-outlined">rule</mat-icon>
</button>
<mat-menu
    #menu="matMenu"
    class="st-cast-secondary-cta-menu">
    <ng-template matMenuContent>
        @if (saveViewSettingsEnabled()) {
            <button
                mat-menu-item
                (click)="saveViewState()">
                {{ languageSettings.PSTWebSaveViewSettings }}
            </button>
        }

        @if (saveAsViewSettingsEnabled()) {
            <button
                mat-menu-item
                (click)="saveAsViewState()">
                {{ languageSettings.PSTWebSaveAsViewSettings }}
            </button>
        }
    </ng-template>
</mat-menu>
